import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * LevelSelector — sélecteur visuel 1-50 réutilisable (cyanotype DEC-014).
 *
 * Layout : grid 10×5 cells. État visuel par cell :
 *   - locked     (level > bestLevel + 1) : grisé, non cliquable, cadenas.
 *   - available  (level <= bestLevel + 1) : cliquable, surface neutre.
 *   - best       (level === bestLevel)    : bordure cyan-network.
 *   - selected   (level === currentLevel) : bg cyan-core, ring cyan-network.
 *
 * Caveat affiché : niveaux 30+ peuvent introduire conditions avancées.
 */
import { MAX_LEVEL, MIN_LEVEL } from '../lib/game-progression';
const COLS = 10;
const ROWS = MAX_LEVEL / COLS;
function cellClasses(args) {
    const { locked, selected, best } = args;
    const base = 'relative flex h-9 w-9 items-center justify-center border font-mono text-[12px] transition';
    if (locked) {
        return `${base} cursor-not-allowed border-cyan-border-faint bg-cyan-bg text-cyan-text-faint`;
    }
    if (selected) {
        return `${base} cursor-pointer border-cyan-network bg-cyan-core text-cyan-surface ring-1 ring-cyan-network`;
    }
    if (best) {
        return `${base} cursor-pointer border-cyan-network bg-cyan-surface text-cyan-text hover:bg-cyan-bg`;
    }
    return `${base} cursor-pointer border-cyan-border bg-cyan-surface text-cyan-text-secondary hover:border-cyan-network hover:text-cyan-text`;
}
export function LevelSelector({ gameSlug, bestLevel, currentLevel, onSelect, }) {
    const unlockCeiling = Math.min(bestLevel + 1, MAX_LEVEL);
    const rows = [];
    for (let r = 0; r < ROWS; r += 1) {
        const row = [];
        for (let c = 0; c < COLS; c += 1) {
            row.push(r * COLS + c + MIN_LEVEL);
        }
        rows.push(row);
    }
    return (_jsxs("div", { className: "flex w-full flex-col gap-3 border border-cyan-border bg-cyan-surface p-4", "data-game-slug": gameSlug, children: [_jsxs("div", { className: "flex items-baseline justify-between gap-3", children: [_jsx("span", { className: "font-mono text-[9.5px] uppercase tracking-[0.20em] text-cyan-network", children: "Niveau" }), _jsxs("span", { className: "text-[12px] text-cyan-text-secondary", children: ["Best ", _jsx("strong", { className: "text-cyan-text", children: bestLevel }), " \u00B7 S\u00E9lection", ' ', _jsx("strong", { className: "text-cyan-text", children: currentLevel })] })] }), _jsx("div", { className: "overflow-x-auto", children: _jsx("div", { className: "flex flex-col gap-2", children: rows.map((row, idx) => (_jsx("div", { className: "flex gap-2", children: row.map((level) => {
                            const locked = level > unlockCeiling;
                            const selected = level === currentLevel;
                            const best = level === bestLevel;
                            return (_jsx("button", { type: "button", "aria-label": locked
                                    ? `Niveau ${level} verrouillé`
                                    : `Sélectionner le niveau ${level}`, "aria-pressed": selected, disabled: locked, onClick: () => {
                                    if (!locked)
                                        onSelect(level);
                                }, className: cellClasses({ locked, selected, best }), children: locked ? (_jsx("span", { "aria-hidden": "true", className: "text-[10px]", children: "\u00B7" })) : (level) }, level));
                        }) }, idx))) }) }), _jsx("p", { className: "text-[10.5px] leading-4 text-cyan-text-secondary", children: "Les niveaux 30+ d\u00E9bloquent des conditions avanc\u00E9es (mouvement, distracteurs)." })] }));
}
export default LevelSelector;
//# sourceMappingURL=LevelSelector.js.map